import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { TextArea } from 'semantic-ui-react';

import { StateType } from '../../reducers';

import { FieldPropsDispatchers, FieldStateProps, TextareaConnectProps } from './types';
import { FieldSet } from './FieldSet';

const TextareaConnect = ({
  label,
  id,
  name,
  modifiers = [],
  autoFocus = false,
  tabIndex = 1,
  disabled = false,
  value,
  placeholder = '',
  required = false,
  dispatchChangeField,
  dispatchOnBlurField,
  errors,
}: TextareaConnectProps) => (
  <FieldSet id={id} label={label} required={required} modifiers={modifiers} errors={errors}>
    <TextArea
      id={id}
      name={name}
      value={value}
      autoFocus={autoFocus}
      placeholder={placeholder}
      tabIndex={tabIndex}
      className="form__textarea"
      disabled={disabled}
      onChange={dispatchChangeField}
      onBlur={dispatchOnBlurField}
    />
  </FieldSet>
);

const mapStateToProps = (state: StateType, ownProps: TextareaConnectProps): FieldStateProps => ({
  value: state.getIn(ownProps.pathValue),
  errors: state.getIn(ownProps.pathErrors),
});

const mapDispatchToProps = (dispatch: Dispatch<any>, ownProps: TextareaConnectProps): FieldPropsDispatchers => ({
  dispatchChangeField: (_: any, data: any) => dispatch(ownProps.onChangeFieldAction(data)),
  dispatchOnBlurField: (event: any) => {
    event.persist();
    dispatch(ownProps.onChangeFieldAction(event));
  },
});

export default connect<FieldStateProps, (dispatch: Dispatch<any>, ownProps: TextareaConnectProps) => FieldPropsDispatchers, any, StateType>(
  mapStateToProps,
  mapDispatchToProps
)(TextareaConnect);
